import { render, staticRenderFns } from "./creatCoupon.vue?vue&type=template&id=74e97ea3&scoped=true&"
import script from "./creatCoupon.vue?vue&type=script&lang=js&"
export * from "./creatCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e97ea3",
  null
  
)

export default component.exports